import React from 'react';
type WidgetKind = 'advanced-chart' | 'ticker-tape' | 'market-overview' | 'mini-symbol-overview';
interface TradingViewWidgetProps {
  /** TradingView embed name, e.g. "advanced-chart". */
  kind?: WidgetKind;
  /** Raw widget configuration, passed straight to the embed script. */
  config: Record<string, unknown>;
  /** Symbol shown in the copyright link (required by TradingView attribution). */
  copyrightSymbol?: string;
  copyrightHref?: string;
  className?: string;
}

/**
 * Mounts an official TradingView embed. The script is injected on mount and
 * cleaned up on unmount, so the widget survives navigation and re-renders.
 */
export function TradingViewWidget({
  kind = 'advanced-chart',
  config,
  copyrightSymbol,
  copyrightHref,
  className = ''
}: TradingViewWidgetProps) {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const serialized = JSON.stringify(config);
  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = '';
    const widget = document.createElement('div');
    widget.className = 'tradingview-widget-container__widget';
    widget.style.height = copyrightSymbol ? 'calc(100% - 32px)' : '100%';
    widget.style.width = '100%';
    container.appendChild(widget);
    if (copyrightSymbol) {
      const copyright = document.createElement('div');
      copyright.className = 'tradingview-widget-copyright';
      copyright.innerHTML = `<a href="${copyrightHref ?? 'https://www.tradingview.com/'}" rel="noopener nofollow" target="_blank"><span class="blue-text">${copyrightSymbol} chart</span></a><span class="trademark"> by TradingView</span>`;
      container.appendChild(copyright);
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://s3.tradingview.com/external-embedding/embed-widget-${kind}.js`;
    script.async = true;
    script.innerHTML = serialized;
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, [kind, serialized, copyrightSymbol, copyrightHref]);
  return <div ref={containerRef} className={`tradingview-widget-container ${className}`} style={{
    height: '100%',
    width: '100%'
  }} data-id="element-200" data-mp="wyq5osq5p2ns" />;
}